import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import WorkflowActionCodeTaskModel from '../../../models/WorkflowActionCodeTaskModel';
import DataService from "../../../services/data.service";
import Action_popup_AddCodeTask from '../Popups/Action_popup_AddCodeTask';

export type Props = {
    workflowActionId: number
}

const Action_tab_CodeTasks: React.FC<Props> = ({ workflowActionId }) => {
    const [data, setData] = useState<WorkflowActionCodeTaskModel[]>();
    const { handleResult, handleException } = useNotifications();
    const [showPopup, setShowPopup] = useState<boolean>(false)

    useEffect(() => {
        getTableData();
    }, [workflowActionId]);

    function getTableData() {
        DataService.get<WorkflowActionCodeTaskModel[]>('api/v1/WorkflowActionCodeTasks/ByWorkflowAction/' + workflowActionId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/WorkflowActionCodeTasks/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    return (
        <>
            <DataTable
                name='dtWorkflowActionCodeTasks'
                tableData={data}
                navigateTitle='Action code task'
                navigateUrl='/plm/WorkflowSetup/ActionCodeTask/'
                colInfos={[
                    { key: true, dataProp: 'id', visible: false },
                    { title: 'Execution order', dataProp: 'executionOrder', sort: 'asc' },
                    { title: 'Code task', dataProp: 'codeTaskName' },
                    { title: 'Parameters', dataProp: 'parameters' },
                    {
                        headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true), applicationFunctions: [ApplicationFunctions.UpdateWorkflowDefinition] }],
                        rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
                    }
                ]}
            />
            {showPopup && <Action_popup_AddCodeTask show={showPopup} onHide={() => { getTableData(); setShowPopup(false) }} workflowActionId={workflowActionId} /> }
        </>
    );
}
export default Action_tab_CodeTasks;